import React, { useState } from "react";

import { useForm } from "react-hook-form";

import { ReactComponent as HideTextSvg } from '../assets/hide_text.svg';
import { ReactComponent as ShowTextSvg } from '../assets/show_text.svg';

import { useHistory, useNavigate } from 'react-router-dom';

import ReactSelect, { components } from "react-select";

import {getAuth, createUserWithEmailAndPassword, sendEmailVerification} from 'firebase/auth';

import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function SignUp({toggleForm}) {

    const {
		register,
		reset,
		handleSubmit,
		formState: { errors },
	} = useForm();

    const navigate = useNavigate();

    const [isShowPassword, setShowPassword] = useState(false);
    const toggle = () => {
        setShowPassword(!isShowPassword);
    };

    const [signup_error, setError] = useState('');


	const fields = [
		{
			name: 'first_name',
			placeholder: 'First name*',
			settings: {
				required: "Please enter your name",
				pattern: '',
			}
		},
		{
			name: 'last_name',
			placeholder: 'Last name',
		},
		{
			name: 'company',
			placeholder: 'Company',
		},
		{
			name: 'role',
			placeholder: 'Role',
		},
		{
			name: 'use',
			placeholder: 'What are you planning to use Lagoon for?',
			type: 'select',
			options: [
				{ value: 'In-person events', label: 'In-person events' },
				{ value: 'Online events', label: 'Online events' },
				{ value: 'Lead generation', label: 'Lead generation' },
				{ value: 'Community activation', label: 'Community activation' },
				{ value: 'other', label: 'other' },
			],
		},
		{
			name: 'email',
			placeholder: 'Email*',
			settings: {
				required: "Please enter your email address",
				pattern: {
					value: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
					message: "Invalid email address",
				}
			}
		},
		{
			name: 'password',
			placeholder: 'Password*',
			type: 'password',
			settings: {
				required: "Please enter your password",
				pattern: {
					value:
						/^[a-zA-Z0-9!@#$%^&*]{6,16}$/,
					message: "Invalid password",
				},
			}
		},
		{
			name: 'repeat_password',
			placeholder: 'Repeat password*',
			type: 'password',
			settings: {
				required: "Please enter your password",
				pattern: {
					value:
						/^[a-zA-Z0-9!@#$%^&*]{6,16}$/,
					message: "Invalid password",
				},
			}
		},
		{
			name: 'code',
			placeholder: 'Registration code*',
			settings: {
				required: "Please enter registration code",
			}
		},

	];

	const SubmitSignUp = async (data) => {

		console.log(data);

		setError(false);

		if (data['password'] != data['repeat_password']){
			setError('Password mismatch');
			return;
		}

		if (data['code'] != 'trylagoon23'){
			setError('Invalid registration code');
			return;
		}

		try {

			const auth = getAuth();

			createUserWithEmailAndPassword(auth, data.email, data.password).then(function(user){

				delete data['password'];
				delete data['repeat_password'];
				delete data['code'];

				data['user'] = auth.currentUser.uid;

				data['account'] = 'free';

				console.log(data);

				const ref = addDoc(collection(db, "admins"), data).then((docRef) => {
					console.log('add admin');
				});

				sendEmailVerification(auth.currentUser)
				.then(() => {

				}).catch((err) => {console.log(err.message)})

			}).catch(function(error) {

				var errorCode = error.code;
				var errorMessage = error.message;
				switch (errorCode){
					case 'auth/weak-password':
						setError('The password is too weak');
						break;
					case 'auth/email-already-in-use':
						setError('Email already in use');
						break;
					case 'auth/invalid-email':
						setError('Invalid email');
						break;
					case 'auth/operation-not-allowed':
						setError('Сan\'t create user');
						break;
					default:
						setError('Сan\'t create user');
				}
				return;
			});

			/*
			{
				"first_name": "eqewrqwer",
				"last_name": "",
				"company": "",
				"role": "",
				"email": "wm-st@yawerwdex.ru",
				"password": "s9Fd8339gwjq",
				"repeat_password": "s9Fd8339gwjq"
			}
			*/



			console.log('success');


		} catch (error) {

			//console.log(error);
		}


	}

	const renderField = (field) => {
		switch (field['type']){
			case 'select':
				return (
					<label>

						<ReactSelect className="filter_status" classNamePrefix="select"
							options={field['options']}
							placeholder={field['placeholder']}
						/>
						<div className="error">{errors[field['name']]?.message}</div>

					</label>
				);

			case 'password':
				return (
					<label className="password">

						<input
						{...register(field['name'], field['settings'])}
						placeholder={field['placeholder']}
						type={isShowPassword ? 'text' : 'password'}
						/>
						<div className="error">{errors[field['name']]?.message}</div>

						<HideTextSvg
							className={isShowPassword ? null : 'hide'}
							onClick={toggle}
						/>
						<ShowTextSvg
							className={isShowPassword ? 'hide': null}
							onClick={toggle}
						/>
					</label>
				);
			default:
				return (
					<label>

						<input
							{...register(field['name'], field['settings'])}
							type="text"
							placeholder={field['placeholder']}
						/>
						<div className="error">{errors[field['name']]?.message}</div>

					</label>
				)
		}
	}


    return (


		<form className="form-auth form-signup">
			<a href="/" className="logo"> </a>

			<div className="fields">
				{fields.map((field, fieldIndex) =>

					<div key={fieldIndex}>
						{renderField(field)}
					</div>

				)}
			</div>

			<label className="submit">
				<button type="submit"
					onClick={handleSubmit((data) => {
						SubmitSignUp(data);
						// reset();
					})}
				>Sign up</button>
				<div className="error">{signup_error}</div>

				<div className="signup-link" onClick={toggleForm}>
					<span>Log in</span>
				</div>
			</label>
		</form>

	);

}
